import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';

import { GqlCustomNavigationItem, CustomNavigationItemType } from 'types/graphql';

import { ModalControllerProps } from './modal-controller';
import { BaseCustomNavigationModal } from './base-custom-navigation-modal';

export function AddSectionModal({ editingItem, onClose, onSave }: ModalControllerProps): JSX.Element {
  const [label, setLabel] = useState(editingItem?.label ?? '');

  const isEditing = !!editingItem;
  const isValid = label.trim() !== '';

  const handleSave = (): void => {
    if (!isValid) {
      return;
    }

    const item: GqlCustomNavigationItem = {
      id: editingItem?.id ?? uuid(),
      items: editingItem?.items ?? [],
      label: label.trim(),
      navigationType: CustomNavigationItemType.section,
      position: editingItem?.position ?? 0,
    };

    onSave(item);
    onClose();
  };

  return (
    <BaseCustomNavigationModal
      copy='Create a section to organize navigation items into a subnavigation.'
      handleSave={handleSave}
      headerText='Section'
      inputLabel={label}
      isEditing={isEditing}
      isOpen
      isValid={isValid}
      onClose={onClose}
      setLabel={setLabel}
    />
  );
}
